module.exports = __webpack_public_path__ + "img/mobile-map.1ba7da99.png";